module.exports = __webpack_public_path__ + "static/media/zone_2.48eb7a22.png";